import { useMemo } from 'react';
import { InviteesGroupEnums } from './InviteesGroup.enums';
import useInviteesGroup from './InviteesGroup.hook';
import * as styles from './InviteesGroup.styles';
import CardSwitch from 'components/CardSwitch';
import FormGroup from 'components/FormGroup';
import { CommonGroups } from 'modules/events/basics/enums/commonForms.enums';
import UploadInvitees from 'modules/events/components/UploadInvitees';
import Box from 'yoda-ui/components/Box';
import Tabs from 'yoda-ui/components/Tabs';
import Tab from 'yoda-ui/components/Tabs/Tab';

const InviteesGroup = () => {
  const { UPLOAD_LIST, PRIVILEGED_LIST } = InviteesGroupEnums;
  const {
    cardSwitchConfig,
    uploadInviteesConfig,
    privilegedUsersConfig,
    openedPanel,
    selectedTab,
    setSelectedTab,
    t,
    tabsConfig,
    isRestrictedAccess,
  } = useInviteesGroup();

  const tabs = useMemo(
    () => (tabsConfig.map(({ label, value }) => (
      <Tab
        key={ value }
        label={ label }
        value={ value }
        sx={ styles.Tab }
      />
    ))),
    [tabsConfig],
  );

  const uploadInviteesPanel = useMemo(
    () => <UploadInvitees { ...uploadInviteesConfig } />,
    [uploadInviteesConfig],
  );
  const privilegedInviteesPanel = useMemo(
    () => <UploadInvitees { ...privilegedUsersConfig } />,
    [privilegedUsersConfig],
  );

  return (
    <>
      <CardSwitch
        name={ cardSwitchConfig.name }
        title={ cardSwitchConfig.title }
        defaultValue={ cardSwitchConfig.defaultValue }
        disabled={ cardSwitchConfig.disabled }
        tooltipTitle={ cardSwitchConfig.tooltipTitle }
      />
      {
        openedPanel && (
          <FormGroup title={ t('inviteesGroup_title') } groupName={ CommonGroups.invitees }>
            <Tabs value={ selectedTab } onChange={ (_, value) => setSelectedTab(value) }>
              { tabs }
            </Tabs>
            <Box hidden={ selectedTab !== UPLOAD_LIST }>
              { uploadInviteesPanel }
            </Box>
            {
              isRestrictedAccess
            && <Box hidden={ selectedTab !== PRIVILEGED_LIST }>
              { privilegedInviteesPanel }
            </Box>
            }
          </FormGroup>
        )
      }
    </>
  );
};

export default InviteesGroup;
